// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type OfferViewModel = {
    offer?: Offer | null;
    quotes?: Array<Quote>;
    policyHolder?: PolicyHolder | null;
    enigmatized?: EnigmatizedOfferViewModel | null;
    allowedBillingFrequencies?: Array<BillingFrequency> | null;
};

export type Offer = {
    id?: string | null;
    validUntil?: string | null;
    billingFrequency?: BillingFrequency | null;
    billingMethod?: BillingMethod | null;
    owner?: string | null;
    channel?: string | null;
    sellerId?: string | null;
    purchaseSuccess?: boolean | null;
    purchaseMessage?: string | null;
    createdTimestamp?: string | null;
    purchaseTimestamp?: string | null;
    priceCalculatedTimestamp?: string | null;
    priceInvalidatedTimestamp?: string | null;
    hasPrice?: boolean | null;
    cultureInfo?: string | null;
};

export const BillingFrequency = {
    /**
     * Monthly
     */
    MONTHLY: 'Monthly',
    /**
     * SemiAnnualy
     */
    SEMI_ANNUALY: 'SemiAnnualy',
    /**
     * Quarterly
     */
    QUARTERLY: 'Quarterly',
    /**
     * Annualy
     */
    ANNUALY: 'Annualy'
} as const;

export type BillingFrequency = typeof BillingFrequency[keyof typeof BillingFrequency];

export const BillingMethod = { /**
     * PaperInvoice
     */
    PAPER_INVOICE: 'PaperInvoice', /**
     * MyPagesInvoice
     */
    MY_PAGES_INVOICE: 'MyPagesInvoice' } as const;

export type BillingMethod = typeof BillingMethod[keyof typeof BillingMethod];

export type Quote = {
    productType?: ProductType;
    policyHolderSsn?: string | null;
    policyHolderStreetAddress?: string | null;
    policyHolderPostalCode?: string | null;
    policyHolderMunicipality?: string | null;
    id?: string | null;
    offerId?: string | null;
    priceCalculatedAt?: string | null;
    committedAt?: string | null;
    coverages?: Array<QuoteCoverage>;
    price?: QuotePrice | null;
    annualNetPrice?: number | null;
    discount?: number | null;
    annualNetPriceDisplay?: string | null;
    monthlyPrice?: number | null;
    monthlyPriceDisplay?: string | null;
};

export const ProductType = {
    /**
     * Travel
     */
    TRAVEL: 'travel',
    /**
     * Householder
     */
    HOUSEHOLDER: 'householder',
    /**
     * Car
     */
    CAR: 'car',
    /**
     * Income
     */
    INCOME: 'income',
    /**
     * Baby
     */
    BABY: 'baby',
    /**
     * Sport
     */
    SPORT: 'sport',
    /**
     * Child
     */
    CHILD: 'child',
    /**
     * Cat
     */
    CAT: 'cat',
    /**
     * Dog
     */
    DOG: 'dog',
    /**
     * Van
     */
    VAN: 'van'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];

export type QuoteCoverage = {
    coverageName?: string;
    deductibleAmount?: number;
    insuranceAmount?: number;
    selected?: boolean;
    selectable?: boolean;
    isAddon?: boolean;
    hasInsuranceAmount?: boolean;
    insuranceAmountOptions?: Array<number>;
    hasDeductible?: boolean;
    deductibleAmountOptions?: Array<number>;
    isCoverageRecommended?: boolean;
    price?: QuotePrice;
    priceParts?: Array<PricePart>;
};

export type QuotePrice = {
    discount?: number;
    discountPercentage?: number | null;
    netAnnual?: number;
    tariffPremium?: number;
    monthlyPrice?: number;
    monthlyPriceDisplay?: string;
    netAnnualDisplay?: string;
    isFixedPrice?: boolean;
};

export type PricePart = {
    name?: string | null;
    netAnnual?: number | null;
};

export type PolicyHolder = {
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    ssn?: string | null;
    ssnLocked?: boolean | null;
    age?: number | null;
    gender?: string | null;
    mobilePhoneNumber?: string | null;
    email?: string | null;
    postalCode?: string | null;
    city?: string | null;
    municipality?: string | null;
    acceptMarketing?: AcceptMarketing | null;
    mcFlag?: number | null;
    informationSource?: InformationSource | null;
    prefilledSsn?: string | null;
};

export const AcceptMarketing = { /**
     * No
     */
    NO: 'No', /**
     * Yes
     */
    YES: 'Yes' } as const;

export type AcceptMarketing = typeof AcceptMarketing[keyof typeof AcceptMarketing];

export const InformationSource = { /**
     * Input
     */
    INPUT: 'Input', /**
     * Scalu
     */
    SCALU: 'Scalu' } as const;

export type InformationSource = typeof InformationSource[keyof typeof InformationSource];

export type EnigmatizedOfferViewModel = OfferViewModel & {
    quotes?: {
        [key: string]: Quote;
    };
    offer?: Offer | null;
    enigmatized?: OfferViewModel | null;
    allowedBillingFrequencies?: Array<BillingFrequency> | null;
};

export type SetQuoteCoverageSelected = {
    selected?: boolean | null;
};

export type SetInsuranceAmount = {
    insuranceAmount?: number | null;
};

export type SetDeductibleAmount = {
    deductibleAmount?: number | null;
};

export type DataList = {
    domain?: string | null;
    language?: string | null;
    id?: string | null;
    items?: Array<Item> | null;
};

export type Item = {
    key?: string | null;
    value?: string | null;
};

export type BrandRow = {
    motorTypeCode?: string | null;
    brand?: string | null;
};

export type BrandAndModelRow = {
    motorTypeCode?: string | null;
    brand?: string | null;
    model?: string | null;
    modelTypeCode?: string | null;
};

export type SiteContent = {
    id?: string | null;
    footerContent?: FooterContent | null;
    topMenuContent?: TopMenuContent | null;
    globalContent?: GlobalContentPage | null;
    confirmationPage?: IfConfirmationPage | null;
    checkoutPage?: IfCheckoutPage | null;
    travelEntryPage?: TravelEntryPage | null;
    travelTopQuestionsPage?: TravelTopQuestionsPage | null;
    travelPricePage?: TravelPricePage | null;
    travelConfirmationPage?: TravelConfirmationPage | null;
    householderConfirmationPage?: HouseholderConfirmationPage | null;
    babyConfirmationPage?: BabyConfirmationPage | null;
    travelCommonPage?: TravelCommonPage | null;
    babyEntryPage?: BabyEntryPage | null;
    babyTopQuestionsPage?: BabyTopQuestionsPage | null;
    babyPricePage?: BabyPricePage | null;
    babyCommonPage?: BabyCommonPage | null;
    vanEntryPage?: VanEntryPage | null;
    vanTopQuestionsPage?: VanTopQuestionsPage | null;
    vanPricePage?: VanPricePage | null;
    householderEntryPage?: HouseholderEntryPage | null;
    householderTopQuestionsPage?: HouseholderTopQuestionsPage | null;
    householderPricePage?: HouseholderPricePage | null;
    householderCommonPage?: HouseholderCommonPage | null;
    childEntryPage?: ChildEntryPage | null;
    childTopQuestionsPage?: ChildTopQuestionsPage | null;
    childPricePage?: ChildPricePage | null;
    childConfirmationPage?: ChildConfirmationPage | null;
    dogEntryPage?: DogEntryPage | null;
    dogTopQuestionsPage?: DogTopQuestionsPage | null;
    dogPricePage?: DogPricePage | null;
    catEntryPage?: CatEntryPage | null;
    catTopQuestionsPage?: CatTopQuestionsPage | null;
    catPricePage?: CatPricePage | null;
    products?: Array<IfProduct>;
};

export type FooterContent = IfContentBase & {
    customerSupportInfoLabel?: OptimizelyValueWrapperOfString | null;
    customerSupportInfoPhoneNumberText?: OptimizelyValueWrapperOfString | null;
    customerSupportInfoOpeningHoursText?: OptimizelyValueWrapperOfString | null;
    ifLogoUrl?: OptimizelyValueWrapperOfString | null;
    nordeaLogoUrl?: OptimizelyValueWrapperOfString | null;
    termsAndCondition?: LinkTextAndUrl | null;
    handlingPersonalData?: LinkTextAndUrl | null;
    cookies?: LinkTextAndUrl | null;
    accessibilityStatement?: LinkTextAndUrl | null;
    inLanguage?: LinkTextAndUrl | null;
    copyright?: OptimizelyValueWrapperOfString | null;
};

export type OptimizelyValueWrapperOfString = {
    value?: string | null;
};

export type LinkTextAndUrl = IfContentBase & {
    text?: OptimizelyValueWrapperOfString | null;
    url?: OptimizelyValueWrapperOfString | null;
};

export type IfContentBase = {
    contentLink?: ContentLink | null;
    name?: string | null;
    url?: string | null;
    contentType?: Array<string>;
    language?: OptimizelyLanguage | null;
    existingLanguages?: Array<OptimizelyLanguage>;
    masterLanguage?: OptimizelyLanguage | null;
};

export type ContentLink = {
    id?: number;
};

export type OptimizelyLanguage = {
    link?: string | null;
    displayName?: string | null;
    name?: string | null;
};

export type TopMenuContent = IfContentBase & {
    privateMenuOption?: LinkTextAndUrl | null;
    companyMenuOption?: LinkTextAndUrl | null;
    largeEnterprisesMenuOption?: LinkTextAndUrl | null;
    insurancesMenuOption?: LinkTextAndUrl | null;
    insurancesMenuOptionNordeaUrl?: OptimizelyValueWrapperOfString | null;
    claimsMenuOption?: LinkTextAndUrl | null;
    customerServiceMenuOption?: LinkTextAndUrl | null;
    logInMenuText?: OptimizelyValueWrapperOfString | null;
    myPageMenuOption?: LinkTextAndUrl | null;
    shoppingBasket?: LinkTextAndUrl | null;
    mobileMenuText?: OptimizelyValueWrapperOfString | null;
};

export type GlobalContentPage = IfContentBase & {
    countrySelectPlaceholderText?: OptimizelyValueWrapperOfString | null;
    cubeDiscount?: CubeDiscountContent | null;
    priceSummarySectionContent?: PriceSummarySectionContent | null;
    electronicHealthDecleration?: ElectronicHealthDeclerationContent | null;
    yesAndNoAnswer?: YesAndNoAnswerContent | null;
    termsLabel?: OptimizelyValueWrapperOfString | null;
    suffixForMonthYear?: CurrencyPeriodSuffix | null;
    closeButton?: OptimizelyValueWrapperOfString | null;
    readMoreLabel?: OptimizelyValueWrapperOfString | null;
};

export type CubeDiscountContent = IfContentBase & {
    modalText?: OptimizelyValueWrapperOfString | null;
    title?: OptimizelyValueWrapperOfString | null;
};

export type PriceSummarySectionContent = IfContentBase & {
    title?: OptimizelyValueWrapperOfString | null;
    priceLabel?: OptimizelyValueWrapperOfString | null;
    addonsInfoLabel?: OptimizelyValueWrapperOfString | null;
    checkOutButtonText?: OptimizelyValueWrapperOfString | null;
    loaderCheckoutText?: OptimizelyValueWrapperOfString | null;
    loaderCalculationText?: OptimizelyValueWrapperOfString | null;
};

export type ElectronicHealthDeclerationContent = IfContentBase & {
    content?: OptimizelyValueWrapperOfString | null;
    title?: OptimizelyValueWrapperOfString | null;
};

export type YesAndNoAnswerContent = IfContentBase & {
    yes?: OptimizelyValueWrapperOfString | null;
    no?: OptimizelyValueWrapperOfString | null;
};

export type CurrencyPeriodSuffix = IfContentBase & {
    month?: OptimizelyValueWrapperOfString | null;
    year?: OptimizelyValueWrapperOfString | null;
};

export type IfConfirmationPage = IfContentBase & {
    confirmationPageCommon?: ConfirmationPageCommon | null;
};

export type ConfirmationPageCommon = IfContentBase & {
    pageHeaderText?: OptimizelyValueWrapperOfString | null;
    totalAmount?: OptimizelyValueWrapperOfString | null;
    aboutInsuranceSectionHeaderText?: OptimizelyValueWrapperOfString | null;
    addOnHeaderText?: OptimizelyValueWrapperOfString | null;
    discountText?: OptimizelyValueWrapperOfString | null;
    secondaryHeader?: OptimizelyValueWrapperOfString | null;
    invoicingSectionHeader?: OptimizelyValueWrapperOfString | null;
    invoicingInfoExistingCustomer?: OptimizelyValueWrapperOfString | null;
    invoicingInfoNewCustomer?: OptimizelyValueWrapperOfString | null;
    myPagesSectionHeader?: OptimizelyValueWrapperOfString | null;
    myPagesText?: OptimizelyValueWrapperOfString | null;
    myPagesScaluText?: OptimizelyValueWrapperOfString | null;
    myPagesButtonText?: OptimizelyValueWrapperOfString | null;
    logoutText?: OptimizelyValueWrapperOfString | null;
    logoutLinkText?: OptimizelyValueWrapperOfString | null;
    logoutLink?: OptimizelyValueWrapperOfString | null;
    cancellationBlock?: OptimizelyValueWrapperOfString | null;
    nordeaCampaignInfo?: OptimizelyValueWrapperOfString | null;
};

export type IfCheckoutPage = IfContentBase & {
    checkoutPageCommon?: CheckoutPageCommon | null;
};

export type CheckoutPageCommon = IfContentBase & {
    title?: OptimizelyValueWrapperOfString | null;
    firstNameQuestion?: QuestionBase | null;
    lastNameQuestion?: QuestionBase | null;
    streetAddressQuestion?: QuestionBase | null;
    postalCodeQuestion?: QuestionBase | null;
    cityQuestion?: QuestionBase | null;
    mobilePhoneNumberQuestion?: QuestionBase | null;
    emailQuestion?: QuestionBase | null;
    billingMethodQuestion?: QuestionBase | null;
    billingFrequencyQuestion?: QuestionBase | null;
    billingHeader?: OptimizelyValueWrapperOfString | null;
    billingInfoMonthlyTextPaperInvoice?: OptimizelyValueWrapperOfString | null;
    billingInfoQuarterSemiAnnualTextPaperInvoice?: OptimizelyValueWrapperOfString | null;
    billingInfoAnnualTextPaperInvoice?: OptimizelyValueWrapperOfString | null;
    billingInfoMonthlyTextMyPagesInvoice?: OptimizelyValueWrapperOfString | null;
    billingInfoQuarterSemiAnnualTextMyPagesInvoice?: OptimizelyValueWrapperOfString | null;
    billingInfoAnnualTextMyPagesInvoice?: OptimizelyValueWrapperOfString | null;
    marketingHeader?: OptimizelyValueWrapperOfString | null;
    marketingDescription?: OptimizelyValueWrapperOfString | null;
    marketingYesLabel?: OptimizelyValueWrapperOfString | null;
    marketingNoLabel?: OptimizelyValueWrapperOfString | null;
    acceptTermsAndConditionsQuestion?: QuestionBase | null;
    submitButtonText?: OptimizelyValueWrapperOfString | null;
    nordeaUnderCtaText?: OptimizelyValueWrapperOfString | null;
    billingInformation?: OptimizelyValueWrapperOfString | null;
    invoicingMethodPaper?: OptimizelyValueWrapperOfString | null;
    invoicingMethodMyPages?: OptimizelyValueWrapperOfString | null;
    invoicingFrequency12Months?: OptimizelyValueWrapperOfString | null;
    invoicingExistingCustomer?: OptimizelyValueWrapperOfString | null;
    marketingConsentRequired?: OptimizelyValueWrapperOfString | null;
    badCreditErrorTitle?: OptimizelyValueWrapperOfString | null;
    badCreditErrorMessage?: OptimizelyValueWrapperOfString | null;
    ssnMismatchErrorTitle?: OptimizelyValueWrapperOfString | null;
    ssnMismatchErrorMessage?: OptimizelyValueWrapperOfString | null;
    pricePageLinkText?: OptimizelyValueWrapperOfString | null;
    completePurchaseLoadingText?: OptimizelyValueWrapperOfString | null;
    acceptTermsAdditionalInfo?: OptimizelyValueWrapperOfString | null;
};

export type QuestionBase = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
    popover?: OptimizelyValueWrapperOfString | null;
    validationMessages?: OptimizelyValueWrapperOfListOfValidationMessageItem | null;
    placeholder?: OptimizelyValueWrapperOfString | null;
};

export type OptimizelyValueWrapperOfListOfValidationMessageItem = {
    value?: Array<ValidationMessageItem> | null;
};

export type ValidationMessageItem = IfContentBase & {
    key?: OptimizelyValueWrapperOfString | null;
    value?: OptimizelyValueWrapperOfString | null;
};

export type TravelEntryPage = IfContentBase & {
    entryPageCommon?: EntryPageCommon | null;
    spouseSsnQuestion?: QuestionBase | null;
    coveredPersonQuestion?: QuestionBase | null;
    coveredPersonMyselfLabel?: OptimizelyValueWrapperOfString | null;
    coveredPersonSpouseLabel?: OptimizelyValueWrapperOfString | null;
};

export type EntryPageCommon = IfContentBase & {
    title?: OptimizelyValueWrapperOfString | null;
    description?: OptimizelyValueWrapperOfString | null;
    subTitle?: OptimizelyValueWrapperOfString | null;
    ssnQuestion?: QuestionBase | null;
    submitButtonText?: OptimizelyValueWrapperOfString | null;
    terms?: OptimizelyValueWrapperOfString | null;
};

export type TravelTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
    familyMemberInformationLabel?: OptimizelyValueWrapperOfString | null;
    familyMemberFirstNameQuestion?: QuestionBase | null;
    familyMemberLastNameQuestion?: QuestionBase | null;
    familyMemberStreetAddressQuestion?: QuestionBase | null;
    familyMemberPostalCodeQuestion?: QuestionBase | null;
    familyMemberMunicipalityQuestion?: QuestionBase | null;
};

export type TopQuestionsCommon = IfContentBase & {
    title?: OptimizelyValueWrapperOfString | null;
    submitButtonText?: OptimizelyValueWrapperOfString | null;
    policyHolderLabel?: OptimizelyValueWrapperOfString | null;
    formTitle?: OptimizelyValueWrapperOfString | null;
};

export type TravelPricePage = IfContentBase & {
    pricePageCommon?: PricePageCommon | null;
};

export type PricePageCommon = IfContentBase & {
    title?: OptimizelyValueWrapperOfString | null;
    policyHolderLabel?: OptimizelyValueWrapperOfString | null;
    editButtonText?: OptimizelyValueWrapperOfString | null;
    submitButtonText?: OptimizelyValueWrapperOfString | null;
    selectAddonsHeader?: OptimizelyValueWrapperOfString | null;
    addonNotSelectableText?: OptimizelyValueWrapperOfString | null;
    includedItemsHeader?: OptimizelyValueWrapperOfString | null;
    recommendedCoverageTitle?: OptimizelyValueWrapperOfString | null;
    recommendedCoverageText?: OptimizelyValueWrapperOfString | null;
    fixedPriceText?: OptimizelyValueWrapperOfString | null;
    recalculatingLoaderText?: OptimizelyValueWrapperOfString | null;
    continuePurchaseLoaderText?: OptimizelyValueWrapperOfString | null;
    deductibleAmountSelector?: LabelBase | null;
    insuranceAmountSelector?: LabelBase | null;
    bonusLabel?: OptimizelyValueWrapperOfString | null;
    nordeaCampaignSummary?: LabelBase | null;
    noCoverageSelectedForAddons?: OptimizelyValueWrapperOfString | null;
    errorMessageNoSelected?: OptimizelyValueWrapperOfString | null;
    topQuestionsTitle?: OptimizelyValueWrapperOfString | null;
};

export type LabelBase = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
    popover?: OptimizelyValueWrapperOfString | null;
    content?: OptimizelyValueWrapperOfString | null;
};

export type TravelConfirmationPage = IfContentBase & {
    confirmationPageCommon?: ConfirmationPageCommon | null;
    nextStepHeader?: OptimizelyValueWrapperOfString | null;
    nextStepMypagesInfoText?: OptimizelyValueWrapperOfString | null;
    nextStepMypagesButtonText?: OptimizelyValueWrapperOfString | null;
    nextStepEhdHeader?: OptimizelyValueWrapperOfString | null;
    nextStepEhdInfo?: OptimizelyValueWrapperOfString | null;
};

export type HouseholderConfirmationPage = IfContentBase & {
    confirmationPageCommon?: ConfirmationPageCommon | null;
};

export type BabyConfirmationPage = IfContentBase & {
    confirmationPageCommon?: ConfirmationPageCommon | null;
    webshopDueDateDistantFuture?: OptimizelyValueWrapperOfString | null;
    nordeaDueDateDistantFuture?: OptimizelyValueWrapperOfString | null;
    webshopDueDateNearFuture?: OptimizelyValueWrapperOfString | null;
    nordeaDueDateNearFuture?: OptimizelyValueWrapperOfString | null;
};

export type TravelCommonPage = IfContentBase & {
    fillTheFormLabel?: OptimizelyValueWrapperOfString | null;
    permanentResidentOfFinlandQuestion?: QuestionBase | null;
    travelInsuranceTypeQuestion?: QuestionBase | null;
    destinationCountryQuestion?: QuestionBase | null;
    startDateQuestion?: QuestionBase | null;
    endDateQuestion?: QuestionBase | null;
    travelInsuranceTypeContinuous?: OptimizelyValueWrapperOfString | null;
    travelInsuranceTypeFixed?: OptimizelyValueWrapperOfString | null;
    postalCodeQuestion?: QuestionBase | null;
};

export type BabyEntryPage = IfContentBase & {
    entryPageCommon?: EntryPageCommon | null;
    babyMotherSsn?: QuestionBase | null;
    insuredParty?: QuestionBase | null;
    insuredPartyIsMother?: OptimizelyValueWrapperOfString | null;
    insuredPartyIsNotMother?: OptimizelyValueWrapperOfString | null;
    expectedDateOfBirth?: QuestionBase | null;
};

export type BabyTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
};

export type BabyPricePage = IfContentBase & {
    pricePageCommon?: PricePageCommon | null;
    firstYearInfoBox?: LabelBase | null;
    customerBenefitInfoBox?: LabelBase | null;
    topQuestionsTitle?: OptimizelyValueWrapperOfString | null;
};

export type BabyCommonPage = IfContentBase & {
    motherFirstName?: QuestionBase | null;
    motherLastName?: QuestionBase | null;
    adress?: QuestionBase | null;
    postalCode?: QuestionBase | null;
    municipality?: QuestionBase | null;
    term?: OptimizelyValueWrapperOfString | null;
    residency?: OptimizelyValueWrapperOfString | null;
    electronicHealthDeclarationTimer?: OptimizelyValueWrapperOfString | null;
};

export type VanEntryPage = IfContentBase & {
    entryPageCommon?: EntryPageCommon | null;
    registrationNumberQuestion?: QuestionBase | null;
};

export type VanTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
    financingCompanyOwnerChoice?: RadioButtonInput | null;
    insuredObjectLabel?: LabelBase | null;
    vehicleRecordsTitleLabel?: LabelBase | null;
    vehicleOwnersTitleLabel?: LabelBase | null;
    complementaryRecordsTitleLabel?: LabelBase | null;
    insuranceRecordsSectionTitleLabel?: LabelBase | null;
    disclaimerLabel?: LabelBase | null;
    financingCompanyDropdownQuestion?: QuestionBase | null;
    complementaryRecordsModelDropdownQuestion?: QuestionBase | null;
    complementaryRecordsMotorVolumeQuestion?: QuestionBase | null;
    complementaryRecordsYearOfManufactureQuestion?: QuestionBase | null;
    complementaryRecordsWeightQuestion?: QuestionBase | null;
    insuranceStartDateQuestion?: QuestionBase | null;
    streetAddressQuestion?: QuestionBase | null;
    postalCodeQuestion?: QuestionBase | null;
};

export type RadioButtonInput = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
    popover?: OptimizelyValueWrapperOfString | null;
    radionButtonValues?: OptimizelyValueWrapperOfListOfRadioButtonValueItem | null;
    validationMessages?: OptimizelyValueWrapperOfListOfValidationMessageItem | null;
};

export type OptimizelyValueWrapperOfListOfRadioButtonValueItem = {
    value?: Array<RadioButtonValueItem> | null;
};

export type RadioButtonValueItem = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
    value?: OptimizelyValueWrapperOfString | null;
    defaultChecked?: OptimizelyValueWrapperOfNullableBoolean | null;
};

export type OptimizelyValueWrapperOfNullableBoolean = {
    value?: boolean | null;
};

export type VanPricePage = IfContentBase & {
    pricePageCommon?: PricePageCommon | null;
    financingCompanyOwnerChoice?: RadioButtonInput | null;
    ownerChoice?: RadioButtonInput | null;
    secondOwnerChoice?: RadioButtonInput | null;
    holdersChoice?: RadioButtonInput | null;
    secondHolderChoice?: RadioButtonInput | null;
    insuredObjectLabel?: LabelBase | null;
    vehicleRecordsTitleLabel?: LabelBase | null;
    complementaryRecordsTitleLabel?: LabelBase | null;
    insuranceRecordsSectionTitleLabel?: LabelBase | null;
    disclaimerLabel?: LabelBase | null;
    vehicleOwnersTitleLabel?: LabelBase | null;
    vehicleHoldersTitleLabel?: LabelBase | null;
    financingCompanyDropdownQuestion?: QuestionBase | null;
    complementaryRecordsModelDropdownQuestion?: QuestionBase | null;
    complementaryRecordsMotorVolumeQuestion?: QuestionBase | null;
    complementaryRecordsYearOfManufactureQuestion?: QuestionBase | null;
    complementaryRecordsWeightQuestion?: QuestionBase | null;
    insuranceStartDateQuestion?: QuestionBase | null;
    streetAddressQuestion?: QuestionBase | null;
    postalCodeQuestion?: QuestionBase | null;
    infoForOwnerAndHolders?: InfoBox | null;
    ownerQuestions?: PersonalDetails | null;
    secondOwnerQuestions?: PersonalDetails | null;
    holderQuestions?: PersonalDetails | null;
    secondHolderQuestions?: PersonalDetails | null;
};

export type InfoBox = IfContentBase & {
    variant?: OptimizelyValueWrapperOfString | null;
    icon?: OptimizelyValueWrapperOfString | null;
    header?: OptimizelyValueWrapperOfString | null;
    popover?: OptimizelyValueWrapperOfString | null;
    content?: OptimizelyValueWrapperOfString | null;
    callToAction?: OptimizelyValueWrapperOfButtonBase | null;
};

export type OptimizelyValueWrapperOfButtonBase = {
    value?: ButtonBase | null;
};

export type ButtonBase = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
};

export type PersonalDetails = IfContentBase & {
    socialSecurityNumber?: QuestionBase | null;
    firstName?: QuestionBase | null;
    lastName?: QuestionBase | null;
    streetAddress?: QuestionBase | null;
    postalCode?: QuestionBase | null;
    postOffice?: QuestionBase | null;
};

export type HouseholderEntryPage = IfContentBase & {
    entryPageCommon?: EntryPageCommon | null;
    householderTypeQuestion?: QuestionBase | null;
    livingSpaceQuestion?: QuestionBase | null;
    isHousingCompanyQuestion?: QuestionBase | null;
};

export type HouseholderTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
    streetAddressQuestion?: QuestionBase | null;
    postalCodeQuestion?: QuestionBase | null;
    cityQuestion?: QuestionBase | null;
    startDateQuestion?: QuestionBase | null;
    formTitle?: OptimizelyValueWrapperOfString | null;
    homeInfoLabel?: LabelBase | null;
    householderInsuredWithIfLabel?: LabelBase | null;
    hasJustMovedInfoText?: OptimizelyValueWrapperOfString | null;
};

export type HouseholderPricePage = IfContentBase & {
    pricePageCommon?: PricePageCommon | null;
    formTitle?: OptimizelyValueWrapperOfString | null;
    householderLabel?: OptimizelyValueWrapperOfString | null;
    houseHolderInfoLabel?: OptimizelyValueWrapperOfString | null;
    houseInformationText?: LabelBase | null;
    streetAddressLabel?: OptimizelyValueWrapperOfString | null;
    postalCodeLabel?: OptimizelyValueWrapperOfString | null;
    cityLabel?: OptimizelyValueWrapperOfString | null;
    termsStartDateLabel?: OptimizelyValueWrapperOfString | null;
    insuredWithIfLabel?: LabelBase | null;
    insuredWithIfInfoText?: OptimizelyValueWrapperOfString | null;
    insuredWithIfInfoLabel?: OptimizelyValueWrapperOfString | null;
    notInsuredWithIfInfoText?: OptimizelyValueWrapperOfString | null;
    notInsuredWithIfInfoLabel?: OptimizelyValueWrapperOfString | null;
};

export type HouseholderCommonPage = IfContentBase & {
    householderInfoM2?: OptimizelyValueWrapperOfString | null;
    householderTypeLabel?: OptimizelyValueWrapperOfString | null;
    householderTypeApartmentLabel?: OptimizelyValueWrapperOfString | null;
    householderTypeRowHouseLabel?: OptimizelyValueWrapperOfString | null;
    householderTypePairHouseLabel?: OptimizelyValueWrapperOfString | null;
    campaignCard?: CampaignCardContent | null;
};

export type CampaignCardContent = IfContentBase & {
    tag?: OptimizelyValueWrapperOfString | null;
    header?: OptimizelyValueWrapperOfString | null;
    modalLabel?: OptimizelyValueWrapperOfString | null;
    modalContent?: OptimizelyValueWrapperOfString | null;
    content?: OptimizelyValueWrapperOfString | null;
};

export type ChildEntryPage = IfContentBase & {
    policyHolderSsn?: QuestionBase | null;
    childSsn?: QuestionBase | null;
    submitButton?: ButtonBase | null;
};

export type ChildTopQuestionsPage = IfContentBase & {
    permanentResidentOfFinlandQuestion?: RadioButtonInput | null;
    childHasLivedInFinlandFor2YearsQuestion?: RadioButtonInput | null;
    areYouTheGuardianQuestion?: RadioButtonInput | null;
    firstNameQuestion?: QuestionBase | null;
    lastNameQuestion?: QuestionBase | null;
    addressQuestion?: QuestionBase | null;
    postalCodeQuestion?: QuestionBase | null;
    municipalityQuestion?: QuestionBase | null;
    coveredPersonSSNLabel?: LabelBase | null;
    topQuestionsCommon?: TopQuestionsCommon | null;
};

export type ChildPricePage = IfContentBase & {
    infoBoxes?: Array<InfoBox> | null;
    pricePageCommon?: PricePageCommon | null;
    topQuestionsCommon?: TopQuestionsCommon | null;
    permanentResidentOfFinlandQuestion?: RadioButtonInput | null;
    childHasLivedInFinlandFor2YearsQuestion?: RadioButtonInput | null;
    areYouTheGuardianQuestion?: RadioButtonInput | null;
    firstNameQuestion?: LabelBase | null;
    lastNameQuestion?: LabelBase | null;
    addressQuestion?: LabelBase | null;
    postalCodeQuestion?: LabelBase | null;
    municipalityQuestion?: LabelBase | null;
    coveredPersonSSNLabel?: LabelBase | null;
};

export type ChildConfirmationPage = IfContentBase & {
    title?: HtmlElement | null;
    nextSteps?: HtmlElement | null;
    titleWide?: HtmlElement | null;
    nextStepsWide?: HtmlElement | null;
    callToAction?: Link | null;
};

export type HtmlElement = IfContentBase & {
    tag?: OptimizelyValueWrapperOfString | null;
    classes?: OptimizelyValueWrapperOfString | null;
    innerHtml?: OptimizelyValueWrapperOfString | null;
};

export type Link = IfContentBase & {
    label?: OptimizelyValueWrapperOfString | null;
    href?: OptimizelyValueWrapperOfString | null;
};

export type DogEntryPage = IfContentBase & {
    policyHolderSsn?: QuestionBase | null;
    dogBreedQuestion?: QuestionBase | null;
    dogNameQuestion?: QuestionBase | null;
    submitButton?: ButtonBase | null;
};

export type DogTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
    dogNameLabel?: LabelBase | null;
    dogBreedLabel?: LabelBase | null;
    dogSexRadios?: RadioButtonInput | null;
    isFromAbroadRadios?: RadioButtonInput | null;
    birthDateQuestion?: QuestionBase | null;
    startDateQuestion?: QuestionBase | null;
    isRegisteredRadios?: RadioButtonInput | null;
    compensationLimitQuestionRegistered?: QuestionBase | null;
    compensationLimitQuestionNotRegistered?: QuestionBase | null;
    policyHolderTitle?: LabelBase | null;
    policyHolderStreetAddressQuestion?: QuestionBase | null;
    policyHolderPostalCodeQuestion?: QuestionBase | null;
    policyHolderMunicipalityQuestion?: QuestionBase | null;
};

export type DogPricePage = IfContentBase & {
    pricePageCommon?: PricePageCommon | null;
    topQuestionsCommon?: TopQuestionsCommon | null;
    dogSexRadios?: RadioButtonInput | null;
    isFromAbroadRadios?: RadioButtonInput | null;
    birthDateQuestion?: QuestionBase | null;
    startDateQuestion?: QuestionBase | null;
    isRegisteredRadios?: RadioButtonInput | null;
    compensationLimitQuestion?: QuestionBase | null;
    policyHolderTitle?: LabelBase | null;
    policyHolderStreetAddressQuestion?: QuestionBase | null;
    policyHolderPostalCodeQuestion?: QuestionBase | null;
    policyHolderMunicipalityQuestion?: QuestionBase | null;
    additionalHealthLabel?: LabelBase | null;
    beenTreatedRadios?: RadioButtonInput | null;
    isHealthyRadios?: RadioButtonInput | null;
    onADietRadios?: RadioButtonInput | null;
    multiSelectProductCommon?: MultiSelectProductCommon | null;
};

export type MultiSelectProductCommon = IfContentBase & {
    totalPriceAmountLabel?: OptimizelyValueWrapperOfString | null;
    noCoverageSelectedForAddons?: OptimizelyValueWrapperOfString | null;
    errorMessageNoSelected?: OptimizelyValueWrapperOfString | null;
};

export type CatEntryPage = IfContentBase & {
    policyHolderSsn?: QuestionBase | null;
    catBreedQuestion?: QuestionBase | null;
    catNameQuestion?: QuestionBase | null;
    submitButton?: ButtonBase | null;
};

export type CatTopQuestionsPage = IfContentBase & {
    topQuestionsCommon?: TopQuestionsCommon | null;
    catInfoLabel?: LabelBase | null;
    catSexRadios?: RadioButtonInput | null;
    isFromAbroadRadios?: RadioButtonInput | null;
    birthDateQuestion?: QuestionBase | null;
    startDateQuestion?: QuestionBase | null;
    isRegisteredRadios?: RadioButtonInput | null;
    compensationLimitRegisteredQuestion?: QuestionBase | null;
    compensationLimitNotRegisteredQuestion?: QuestionBase | null;
    policyHolderTitle?: LabelBase | null;
    policyHolderStreetAddressQuestion?: QuestionBase | null;
    policyHolderPostalCodeQuestion?: QuestionBase | null;
    policyHolderMunicipalityQuestion?: QuestionBase | null;
};

export type CatPricePage = IfContentBase & {
    catInfoLabel?: LabelBase | null;
    catSexLabel?: RadioButtonInput | null;
    isImportedLabel?: RadioButtonInput | null;
    birthDateLabel?: QuestionBase | null;
    startDateLabel?: QuestionBase | null;
    isRegisteredLabel?: RadioButtonInput | null;
    compensationLimitRegisteredLabel?: QuestionBase | null;
    compensationLimitNotRegisteredLabel?: QuestionBase | null;
    policyHolderLabel?: LabelBase | null;
    policyHolderStreetAddressLabel?: LabelBase | null;
    policyHolderPostalCodeLabel?: LabelBase | null;
    policyHolderMunicipalityLabel?: LabelBase | null;
    additionalHealthTitle?: LabelBase | null;
    hasVeterinaryTreatment?: RadioButtonInput | null;
    isSymptomFree?: RadioButtonInput | null;
    hasRegularMedication?: RadioButtonInput | null;
    pricePageCommon?: PricePageCommon | null;
    multiSelectProductCommon?: MultiSelectProductCommon | null;
};

export type IfProduct = IfContentBase & {
    internalId?: OptimizelyValueWrapperOfString | null;
    productType?: OptimizelyValueWrapperOfString | null;
    coreName?: OptimizelyValueWrapperOfString | null;
    coverages?: OptimizelyValueWrapperOfListOfCoverage | null;
    addons?: OptimizelyValueWrapperOfListOfAddon | null;
    includedItems?: OptimizelyValueWrapperOfListOfIncludedItem | null;
    termsAndConditions?: OptimizelyValueWrapperOfListOfTermsAndConditionItem | null;
};

export type OptimizelyValueWrapperOfListOfCoverage = {
    value?: Array<Coverage> | null;
};

export type Coverage = IfContentBase & {
    coreName?: OptimizelyValueWrapperOfString | null;
    displayName?: OptimizelyValueWrapperOfString | null;
    description?: OptimizelyValueWrapperOfString | null;
    sortOrder?: OptimizelyValueWrapperOfNullableInteger | null;
    recommended?: OptimizelyValueWrapperOfNullableBoolean | null;
    fixedPrice?: OptimizelyValueWrapperOfNullableBoolean | null;
};

export type OptimizelyValueWrapperOfNullableInteger = {
    value?: number | null;
};

export type OptimizelyValueWrapperOfListOfAddon = {
    value?: Array<Addon> | null;
};

export type Addon = IfContentBase & {
    coreName?: OptimizelyValueWrapperOfString | null;
    displayName?: OptimizelyValueWrapperOfString | null;
    description?: OptimizelyValueWrapperOfString | null;
    sellingPoints?: OptimizelyValueWrapperOfListOfString | null;
    modalDescription?: OptimizelyValueWrapperOfString | null;
    sortOrder?: OptimizelyValueWrapperOfNullableInteger | null;
    recommended?: OptimizelyValueWrapperOfNullableBoolean | null;
    recommendedLabel?: OptimizelyValueWrapperOfString | null;
    fixedPrice?: OptimizelyValueWrapperOfNullableBoolean | null;
};

export type OptimizelyValueWrapperOfListOfString = {
    value?: Array<string> | null;
};

export type OptimizelyValueWrapperOfListOfIncludedItem = {
    value?: Array<IncludedItem> | null;
};

export type IncludedItem = IfContentBase & {
    itemName?: OptimizelyValueWrapperOfString | null;
    sortOrder?: OptimizelyValueWrapperOfInteger | null;
    includedWithCoverages?: OptimizelyValueWrapperOfString | null;
    popoverText?: OptimizelyValueWrapperOfString | null;
    rowExpandedText?: OptimizelyValueWrapperOfString | null;
    icon?: OptimizelyValueWrapperOfString | null;
};

export type OptimizelyValueWrapperOfInteger = {
    value?: number;
};

export type OptimizelyValueWrapperOfListOfTermsAndConditionItem = {
    value?: Array<TermsAndConditionItem> | null;
};

export type TermsAndConditionItem = IfContentBase & {
    href?: OptimizelyValueWrapperOfString | null;
    label?: OptimizelyValueWrapperOfString | null;
};

export type AddQuoteResult = {
    id?: string | null;
    offer?: OfferViewModel | null;
};

export type VanQuote = Quote & {
    registrationNumber?: string | null;
    startDate?: string | null;
    firstOwner?: VanPerson | null;
    secondOwner?: VanPerson | null;
    secondHolder?: VanPerson | null;
    financeCompanyId?: string | null;
    vanDetails?: VanDetails | null;
    vanRegistrationDetails?: VanRegistrationDetails | null;
    vanBonusDetails?: VanBonusDetails | null;
    isCustGivingInfo?: boolean | null;
};

export type VanPerson = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    city?: string | null;
    postalCode?: string | null;
};

export type VanDetails = {
    brand?: string | null;
    model?: string | null;
    cylinderVolume?: number | null;
    manufactureYear?: number | null;
    totalWeight?: number | null;
};

export type VanRegistrationDetails = {
    insuranceRegistrationStatus?: boolean | null;
    electronicInsuranceCompanyChangeState?: boolean | null;
    role?: OwnerHolderRole | null;
};

export const OwnerHolderRole = {
    /**
     * Unknown
     */
    UNKNOWN: 'Unknown',
    /**
     * Holder
     */
    HOLDER: 'Holder',
    /**
     * Owner
     */
    OWNER: 'Owner',
    /**
     * OwnerHolder
     */
    OWNER_HOLDER: 'OwnerHolder',
    /**
     * SecondOwner
     */
    SECOND_OWNER: 'SecondOwner',
    /**
     * SecondHolder
     */
    SECOND_HOLDER: 'SecondHolder'
} as const;

export type OwnerHolderRole = typeof OwnerHolderRole[keyof typeof OwnerHolderRole];

export type VanBonusDetails = {
    trafficInsuranceBonus?: number | null;
    cascoBonus?: number | null;
};

export type TravelQuote = Quote & {
    maximumTravelLengthInDays?: number | null;
    coveragePeriod?: CoveragePeriod | null;
    destinationCountry?: string | null;
    travelLength?: number | null;
    fixedCoverageSelected?: boolean;
    coveredPerson: TravelCoveredPerson;
};

export type CoveragePeriod = {
    startDate?: string | null;
    endDate?: string | null;
    termPeriod?: TermPeriod | null;
};

export const TermPeriod = { /**
     * Fixed
     */
    FIXED: 'Fixed', /**
     * Continuous
     */
    CONTINUOUS: 'Continuous' } as const;

export type TermPeriod = typeof TermPeriod[keyof typeof TermPeriod];

export type TravelCoveredPerson = {
    postalCode?: string | null;
    permanentResidentOfFinland?: number | null;
    familyMember?: TravelFamilyMember | null;
    insuredParty?: InsuredParty | null;
};

export type TravelFamilyMember = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    municipality?: string | null;
};

export const InsuredParty = { /**
     * PolicyHolder
     */
    POLICY_HOLDER: 'PolicyHolder', /**
     * FamilyMember
     */
    FAMILY_MEMBER: 'FamilyMember' } as const;

export type InsuredParty = typeof InsuredParty[keyof typeof InsuredParty];

export type SportQuote = Quote & {
    sportChild?: SportChild | null;
    city?: string | null;
    sportCode?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    municipality?: string | null;
    insuredParty?: SportInsuredParty | null;
};

export type SportChild = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
};

export const SportInsuredParty = { /**
     * PolicyHolder
     */
    POLICY_HOLDER: 'PolicyHolder', /**
     * SportChild
     */
    SPORT_CHILD: 'SportChild' } as const;

export type SportInsuredParty = typeof SportInsuredParty[keyof typeof SportInsuredParty];

export type IncomeQuote = Quote & {
    isRetired?: boolean | null;
    incomeCoveredPerson?: IncomeCoveredPerson | null;
};

export type IncomeCoveredPerson = {
    familyMember?: IncomeFamilyMember | null;
    insuredParty?: IncomeInsuredParty | null;
};

export type IncomeFamilyMember = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    city?: string | null;
};

export const IncomeInsuredParty = { /**
     * PolicyHolder
     */
    POLICY_HOLDER: 'PolicyHolder', /**
     * FamilyMember
     */
    FAMILY_MEMBER: 'FamilyMember' } as const;

export type IncomeInsuredParty = typeof IncomeInsuredParty[keyof typeof IncomeInsuredParty];

export type HouseholderQuote = Quote & {
    householder: Householder;
    terms?: HouseholderTerms | null;
    isHousingCompany?: boolean | null;
};

export type Householder = {
    householderType?: HouseholderType | null;
    livingSpace?: number | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    city?: string | null;
    householderInsuredWithIf?: boolean | null;
};

export const HouseholderType = {
    /**
     * Apartment
     */
    APARTMENT: 'Apartment',
    /**
     * RowHouse
     */
    ROW_HOUSE: 'RowHouse',
    /**
     * PairHouse
     */
    PAIR_HOUSE: 'PairHouse'
} as const;

export type HouseholderType = typeof HouseholderType[keyof typeof HouseholderType];

export type HouseholderTerms = {
    startDate?: string | null;
};

export type DogQuote = Quote & {
    dogCovered: DogCovered;
};

export type DogCovered = {
    dogSex?: DogSex | null;
    dogName?: string | null;
    dogBreed?: string | null;
    startDate?: string | null;
    birthDate?: string | null;
    isRegistered?: boolean | null;
    compensationLimit?: number | null;
    isFromAbroad?: boolean | null;
};

export const DogSex = { /**
     * Male
     */
    MALE: 'Male', /**
     * Female
     */
    FEMALE: 'Female' } as const;

export type DogSex = typeof DogSex[keyof typeof DogSex];

export type ChildQuote = Quote & {
    coveredPerson?: ChildCoveredPerson | null;
    guardianType?: ChildGuardianType | null;
    guardianInfo?: ChildGuardianInfo | null;
};

export type ChildCoveredPerson = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    municipality?: string | null;
    city?: string | null;
    childHasLivedInFinlandFor2Years?: boolean | null;
};

export const ChildGuardianType = { /**
     * PolicyHolder
     */
    POLICY_HOLDER: 'PolicyHolder', /**
     * OtherPerson
     */
    OTHER_PERSON: 'OtherPerson' } as const;

export type ChildGuardianType = typeof ChildGuardianType[keyof typeof ChildGuardianType];

export type ChildGuardianInfo = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    city?: string | null;
};

export type CatQuote = Quote & {
    catCovered: CatCovered;
};

export type CatCovered = {
    catSex?: CatSex | null;
    catName?: string | null;
    catBreed?: string | null;
    startDate?: string | null;
    birthDate?: string | null;
    isRegistered?: boolean | null;
    compensationLimit?: number | null;
    isFromAbroad?: boolean | null;
    hasVeterinaryTreatment?: boolean | null;
    isSymptomFree?: boolean | null;
    hasRegularMedication?: boolean | null;
};

export const CatSex = { /**
     * Male
     */
    MALE: 'Male', /**
     * Female
     */
    FEMALE: 'Female' } as const;

export type CatSex = typeof CatSex[keyof typeof CatSex];

export type BabyQuote = Quote & {
    babyMother?: BabyMother | null;
    expectedDateOfBirth?: string | null;
    streetAddress?: string | null;
    postalCode?: string | null;
    city?: string | null;
    municipality?: string | null;
    insuredParty?: BabyInsuredParty | null;
    dueDateForEhd?: string | null;
};

export type BabyMother = {
    ssn?: string | null;
    firstName?: string | null;
    lastName?: string | null;
};

export const BabyInsuredParty = { /**
     * PolicyHolder
     */
    POLICY_HOLDER: 'PolicyHolder', /**
     * Mother
     */
    MOTHER: 'Mother' } as const;

export type BabyInsuredParty = typeof BabyInsuredParty[keyof typeof BabyInsuredParty];

export type ClientConfiguration = {
    recaptchaSiteKey?: string | null;
    appInsightsConnectionString?: string | null;
    content?: SiteContent | null;
    clientAppEntry?: ManifestEntry | null;
    gtmContainerId?: string | null;
    basePath?: string | null;
};

export type ManifestEntry = {
    file?: string | null;
    name?: string | null;
    src?: string | null;
    isEntry?: boolean | null;
    isDynamicEntry?: boolean | null;
    imports?: Array<string>;
    dynamicImports?: Array<string>;
    css?: Array<string>;
};

export type PublicCustomerContext = {
    publicId?: string | null;
    contextIdByOfferId?: {
        [key: string]: string;
    };
    currentOfferId?: string | null;
    persistedAt?: string | null;
    skipCart?: boolean | null;
    language?: string | null;
    channel?: Channel | null;
};

export const Channel = { /**
     * Nordea
     */
    NORDEA: 'NU', /**
     * WebShop
     */
    WEB_SHOP: 'WS' } as const;

export type Channel = typeof Channel[keyof typeof Channel];

export type WebShopPublicUser = {
    isAuthenticated?: boolean;
    ssn?: string | null;
    givenName?: string | null;
};

export type CoveragePutData = {
    body: SetQuoteCoverageSelected;
    path: {
        id: string;
        coverageName: string;
    };
    query?: never;
    url: '/api/quote/{id}/coverage/{coverageName}';
};

export type CoveragePutResponses = {
    200: OfferViewModel;
};

export type CoveragePutResponse = CoveragePutResponses[keyof CoveragePutResponses];

export type CoverageSetInsuranceAmountData = {
    body: SetInsuranceAmount;
    path: {
        id: string;
        coverageName: string;
    };
    query?: never;
    url: '/api/quote/{id}/coverage/{coverageName}/insuranceAmount';
};

export type CoverageSetInsuranceAmountResponses = {
    200: OfferViewModel;
};

export type CoverageSetInsuranceAmountResponse = CoverageSetInsuranceAmountResponses[keyof CoverageSetInsuranceAmountResponses];

export type CoverageSetDeductibleAmountData = {
    body: SetDeductibleAmount;
    path: {
        id: string;
        coverageName: string;
    };
    query?: never;
    url: '/api/quote/{id}/coverage/{coverageName}/deductibleAmount';
};

export type CoverageSetDeductibleAmountResponses = {
    200: OfferViewModel;
};

export type CoverageSetDeductibleAmountResponse = CoverageSetDeductibleAmountResponses[keyof CoverageSetDeductibleAmountResponses];

export type QuoteDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Quote/{id}';
};

export type QuoteDeleteResponses = {
    200: Blob | File;
};

export type QuoteDeleteResponse = QuoteDeleteResponses[keyof QuoteDeleteResponses];

export type QuoteAddToCartData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Quote/{id}/addToCart';
};

export type QuoteAddToCartResponses = {
    200: Blob | File;
};

export type QuoteAddToCartResponse = QuoteAddToCartResponses[keyof QuoteAddToCartResponses];

export type QuoteCalculateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Quote/{id}/calculate';
};

export type QuoteCalculateResponses = {
    200: Blob | File;
};

export type QuoteCalculateResponse = QuoteCalculateResponses[keyof QuoteCalculateResponses];

export type PolicyHolderPutData = {
    body: PolicyHolder;
    path?: never;
    query?: never;
    url: '/api/PolicyHolder';
};

export type PolicyHolderPutResponses = {
    200: OfferViewModel;
};

export type PolicyHolderPutResponse = PolicyHolderPutResponses[keyof PolicyHolderPutResponses];

export type CalculatePutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Calculate';
};

export type CalculatePutResponses = {
    200: OfferViewModel;
};

export type CalculatePutResponse = CalculatePutResponses[keyof CalculatePutResponses];

export type CheckoutGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Checkout';
};

export type CheckoutGetResponses = {
    200: Blob | File;
};

export type CheckoutGetResponse = CheckoutGetResponses[keyof CheckoutGetResponses];

export type CheckoutPutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Checkout';
};

export type CheckoutPutResponses = {
    200: OfferViewModel;
};

export type CheckoutPutResponse = CheckoutPutResponses[keyof CheckoutPutResponses];

export type OfferGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Offer';
};

export type OfferGetResponses = {
    200: OfferViewModel;
};

export type OfferGetResponse = OfferGetResponses[keyof OfferGetResponses];

export type OfferPutData = {
    body: Offer;
    path?: never;
    query?: never;
    url: '/api/Offer';
};

export type OfferPutResponses = {
    200: OfferViewModel;
};

export type OfferPutResponse = OfferPutResponses[keyof OfferPutResponses];

export type OfferGetByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Offer/{id}';
};

export type OfferGetByIdResponses = {
    200: OfferViewModel;
};

export type OfferGetByIdResponse = OfferGetByIdResponses[keyof OfferGetByIdResponses];

export type CoreDataGetMunicipalitiesData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/municipalities';
};

export type CoreDataGetMunicipalitiesResponses = {
    200: DataList;
};

export type CoreDataGetMunicipalitiesResponse = CoreDataGetMunicipalitiesResponses[keyof CoreDataGetMunicipalitiesResponses];

export type CoreDataGetCountriesData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/countries';
};

export type CoreDataGetCountriesResponses = {
    200: DataList;
};

export type CoreDataGetCountriesResponse = CoreDataGetCountriesResponses[keyof CoreDataGetCountriesResponses];

export type CoreDataGetPostalCodesData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/postalCodes';
};

export type CoreDataGetPostalCodesResponses = {
    200: DataList;
};

export type CoreDataGetPostalCodesResponse = CoreDataGetPostalCodesResponses[keyof CoreDataGetPostalCodesResponses];

export type CoreDataGetSportTypesData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/sportTypes';
};

export type CoreDataGetSportTypesResponses = {
    200: DataList;
};

export type CoreDataGetSportTypesResponse = CoreDataGetSportTypesResponses[keyof CoreDataGetSportTypesResponses];

export type CoreDataGetCatBreedsData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/catBreeds';
};

export type CoreDataGetCatBreedsResponses = {
    200: DataList;
};

export type CoreDataGetCatBreedsResponse = CoreDataGetCatBreedsResponses[keyof CoreDataGetCatBreedsResponses];

export type CoreDataGetDogBreedsData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/dogBreeds';
};

export type CoreDataGetDogBreedsResponses = {
    200: DataList;
};

export type CoreDataGetDogBreedsResponse = CoreDataGetDogBreedsResponses[keyof CoreDataGetDogBreedsResponses];

export type CoreDataGetFinanceCompaniesData = {
    body?: never;
    path?: never;
    query?: {
        language?: string | null;
    };
    url: '/api/CoreData/financeCompanies';
};

export type CoreDataGetFinanceCompaniesResponses = {
    200: DataList;
};

export type CoreDataGetFinanceCompaniesResponse = CoreDataGetFinanceCompaniesResponses[keyof CoreDataGetFinanceCompaniesResponses];

export type CoreDataGetVanMakersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/CoreData/vanMakers';
};

export type CoreDataGetVanMakersResponses = {
    200: Array<BrandRow>;
};

export type CoreDataGetVanMakersResponse = CoreDataGetVanMakersResponses[keyof CoreDataGetVanMakersResponses];

export type CoreDataGetVanMakersAndModelsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/CoreData/vanMakersAndModels';
};

export type CoreDataGetVanMakersAndModelsResponses = {
    200: Array<BrandAndModelRow>;
};

export type CoreDataGetVanMakersAndModelsResponse = CoreDataGetVanMakersAndModelsResponses[keyof CoreDataGetVanMakersAndModelsResponses];

export type CoreDataGetVanModelsByMakerData = {
    body?: never;
    path?: never;
    query?: {
        maker?: string | null;
    };
    url: '/api/CoreData/vanModelsByMaker';
};

export type CoreDataGetVanModelsByMakerResponses = {
    200: Array<BrandAndModelRow>;
};

export type CoreDataGetVanModelsByMakerResponse = CoreDataGetVanModelsByMakerResponses[keyof CoreDataGetVanModelsByMakerResponses];

export type ContentGetData = {
    body?: never;
    path: {
        language: string | null;
    };
    query?: never;
    url: '/api/Content/{language}';
};

export type ContentGetResponses = {
    200: SiteContent;
};

export type ContentGetResponse = ContentGetResponses[keyof ContentGetResponses];

export type VanPostData = {
    body: VanQuote;
    path?: never;
    query?: never;
    url: '/api/Van';
};

export type VanPostResponses = {
    200: AddQuoteResult;
};

export type VanPostResponse = VanPostResponses[keyof VanPostResponses];

export type VanPutData = {
    body: VanQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Van/{id}';
};

export type VanPutResponses = {
    200: OfferViewModel;
};

export type VanPutResponse = VanPutResponses[keyof VanPutResponses];

export type TravelPostData = {
    body: TravelQuote;
    path?: never;
    query?: never;
    url: '/api/Travel';
};

export type TravelPostResponses = {
    200: AddQuoteResult;
};

export type TravelPostResponse = TravelPostResponses[keyof TravelPostResponses];

export type TravelPutData = {
    body: TravelQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Travel/{id}';
};

export type TravelPutResponses = {
    200: OfferViewModel;
};

export type TravelPutResponse = TravelPutResponses[keyof TravelPutResponses];

export type SportPostData = {
    body: SportQuote;
    path?: never;
    query?: never;
    url: '/api/Sport';
};

export type SportPostResponses = {
    200: AddQuoteResult;
};

export type SportPostResponse = SportPostResponses[keyof SportPostResponses];

export type SportPutData = {
    body: SportQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Sport/{id}';
};

export type SportPutResponses = {
    200: OfferViewModel;
};

export type SportPutResponse = SportPutResponses[keyof SportPutResponses];

export type IncomePostData = {
    body: IncomeQuote;
    path?: never;
    query?: never;
    url: '/api/Income';
};

export type IncomePostResponses = {
    200: AddQuoteResult;
};

export type IncomePostResponse = IncomePostResponses[keyof IncomePostResponses];

export type IncomePutData = {
    body: IncomeQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Income/{id}';
};

export type IncomePutResponses = {
    200: OfferViewModel;
};

export type IncomePutResponse = IncomePutResponses[keyof IncomePutResponses];

export type HouseholderPostData = {
    body: HouseholderQuote;
    path?: never;
    query?: never;
    url: '/api/Householder';
};

export type HouseholderPostResponses = {
    200: AddQuoteResult;
};

export type HouseholderPostResponse = HouseholderPostResponses[keyof HouseholderPostResponses];

export type HouseholderPutData = {
    body: HouseholderQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Householder/{id}';
};

export type HouseholderPutResponses = {
    200: OfferViewModel;
};

export type HouseholderPutResponse = HouseholderPutResponses[keyof HouseholderPutResponses];

export type DogPostData = {
    body: DogQuote;
    path?: never;
    query?: never;
    url: '/api/Dog';
};

export type DogPostResponses = {
    200: AddQuoteResult;
};

export type DogPostResponse = DogPostResponses[keyof DogPostResponses];

export type DogPutData = {
    body: DogQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Dog/{id}';
};

export type DogPutResponses = {
    200: OfferViewModel;
};

export type DogPutResponse = DogPutResponses[keyof DogPutResponses];

export type ChildPostData = {
    body: ChildQuote;
    path?: never;
    query?: never;
    url: '/api/Child';
};

export type ChildPostResponses = {
    200: AddQuoteResult;
};

export type ChildPostResponse = ChildPostResponses[keyof ChildPostResponses];

export type ChildPutData = {
    body: ChildQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Child/{id}';
};

export type ChildPutResponses = {
    200: OfferViewModel;
};

export type ChildPutResponse = ChildPutResponses[keyof ChildPutResponses];

export type CatPostData = {
    body: CatQuote;
    path?: never;
    query?: never;
    url: '/api/Cat';
};

export type CatPostResponses = {
    200: AddQuoteResult;
};

export type CatPostResponse = CatPostResponses[keyof CatPostResponses];

export type CatPutData = {
    body: CatQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Cat/{id}';
};

export type CatPutResponses = {
    200: OfferViewModel;
};

export type CatPutResponse = CatPutResponses[keyof CatPutResponses];

export type BabyPostData = {
    body: BabyQuote;
    path?: never;
    query?: never;
    url: '/api/Baby';
};

export type BabyPostResponses = {
    200: AddQuoteResult;
};

export type BabyPostResponse = BabyPostResponses[keyof BabyPostResponses];

export type BabyPutData = {
    body: BabyQuote;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/Baby/{id}';
};

export type BabyPutResponses = {
    200: OfferViewModel;
};

export type BabyPutResponse = BabyPutResponses[keyof BabyPutResponses];

export type AntiForgeryGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/AntiForgery';
};

export type AntiForgeryGetResponses = {
    200: ClientConfiguration;
};

export type AntiForgeryGetResponse = AntiForgeryGetResponses[keyof AntiForgeryGetResponses];

export type ConfigurationGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Configuration';
};

export type ConfigurationGetResponses = {
    200: ClientConfiguration;
};

export type ConfigurationGetResponse = ConfigurationGetResponses[keyof ConfigurationGetResponses];

export type CustomerContextGetContextData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/CustomerContext/GetContext';
};

export type CustomerContextGetContextResponses = {
    200: PublicCustomerContext;
};

export type CustomerContextGetContextResponse = CustomerContextGetContextResponses[keyof CustomerContextGetContextResponses];

export type CustomerContextUpdateContextData = {
    body: PublicCustomerContext;
    path?: never;
    query?: never;
    url: '/api/CustomerContext/UpdateContext';
};

export type CustomerContextUpdateContextResponses = {
    200: PublicCustomerContext;
};

export type CustomerContextUpdateContextResponse = CustomerContextUpdateContextResponses[keyof CustomerContextUpdateContextResponses];

export type AuthLoginData = {
    body?: never;
    path?: never;
    query?: {
        redirectUri?: string | null;
    };
    url: '/api/Auth/Login';
};

export type AuthLoginResponses = {
    200: Blob | File;
};

export type AuthLoginResponse = AuthLoginResponses[keyof AuthLoginResponses];

export type AuthGetUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/Auth/GetUser';
};

export type AuthGetUserResponses = {
    200: WebShopPublicUser;
};

export type AuthGetUserResponse = AuthGetUserResponses[keyof AuthGetUserResponses];

export type AuthLogoutData = {
    body?: never;
    path?: never;
    query?: {
        redirectUri?: string | null;
    };
    url: '/api/Auth/Logout';
};

export type AuthLogoutResponses = {
    200: Blob | File;
};

export type AuthLogoutResponse = AuthLogoutResponses[keyof AuthLogoutResponses];
